<template>
    <ul
        id="catalog-breadcrumb"
        class="cr-breadcrumb"
        itemscope
        itemtype="http://schema.org/BreadcrumbList">
        <li v-for="(breadcrumb, index) in breadcrumbs()"
            itemprop="itemListElement"
            itemscope
            itemtype="http://schema.org/ListItem">
            <a v-if="breadcrumb.url && breadcrumb.url.substring(0, 4) === 'http'" :href="breadcrumb.url"
               itemprop="item">
                <span itemprop="name">
                    {{ breadcrumb.name }}
                </span>
            </a>
            <a v-else-if="breadcrumb.url"
               :href="`${$scope.URL}${breadcrumb.url}`"
               itemprop="item">
                <span itemprop="name">
                    {{ breadcrumb.name }}
                </span>
            </a>
            <a v-else
               :href="breadcrumb.url"
               itemprop="item">
                <span itemprop="name">
                    {{ breadcrumb.name }}
                </span>
            </a>

            <meta itemprop="position"
                  :content="index + 1"/>
        </li>
    </ul>
</template>

<script>
    import {catalogStore} from "../../common/store/catalog-store";

    export default {
        name: "CatalogBreadcrumbs",

        data() {
            return {
                storeState: catalogStore.state
            }
        },

        computed: {
            selected() {
                return this.storeState.selected;
            }
        },

        methods: {
            breadcrumbs() {
                let breadcrumbs = [];

                if (this.selected.query) {
                    breadcrumbs.push({name: 'Busca'});
                    breadcrumbs.push({name: this.selected.query, url: window.location.href});
                    return breadcrumbs;
                }

                if (this.selected.tags) {
                    breadcrumbs.push({name: 'Tag'});
                    breadcrumbs.push({name: this.selected.tags, url: window.location.href});
                    return breadcrumbs;
                }

                if (this.selected.partner) {
                    breadcrumbs.push({name: 'Loja ' + this.selected.partner_name, url: this.selected.partner_url});
                    return breadcrumbs;
                }

                if (this.selected.type_main_url && this.selected.type_main_url !== 'loja') {
                    const name = this.selected.type_main_url.charAt(0).toUpperCase() + this.selected.type_main_url.slice(1);
                    breadcrumbs.push({name, url: this.selected.type_main_url + '/'});
                }

                let path = '';

                if (this.selected.type_id > 0) {
                    path = path + this.selected.type_url + '/';
                    breadcrumbs.push({name: this.selected.type_name, url: path});
                }
                if (this.selected.category > 0) {
                    path = path + this.selected.category_url + '/';
                    breadcrumbs.push({name: this.selected.category_name, url: path});
                }
                if (this.selected.gender) {
                    path = path + this.selected.gender_url + '/';
                    breadcrumbs.push({name: this.selected.gender_name, url: path});
                }

                return breadcrumbs;
            },
        }
    }
</script>